import React, {FC, ReactNode} from 'react';
import styled, {css} from 'styled-components';

import {VisualSizesEnum} from '../../../../libs/shared/ui/src/styles/commonStyles';
import {FloatingBar} from './floatingBar';

/*
 * Props.
 */

interface FloatingToolbarProps {
  children: ReactNode;
  size?: VisualSizesEnum;
}

/*
 * Style.
 */

const stylesBySize = {
  [VisualSizesEnum.SMALL]: css`
    padding: 2px;
    border-radius: 6px;
  `,
  [VisualSizesEnum.MEDIUM]: css`
    padding: 4px;
    border-radius: 8px;
  `,
  [VisualSizesEnum.LARGE]: css`
    padding: 5px;
    border-radius: 6px;
  `,
  [VisualSizesEnum.EXTRA_LARGE]: css`
    padding: 6px 5px;
  `,
};

const StyledFloatingBar = styled(FloatingBar)<{
  $size: VisualSizesEnum;
}>`
  display: flex;
  color: ${(p) => p.theme.greys.shade50};
  background-color: ${(p) => p.theme.greys.shade90};

  ${(p) => stylesBySize[p.$size]};
`;

/*
 * Component.
 */

export const FloatingToolbar: FC<FloatingToolbarProps> = (props) => (
  <StyledFloatingBar $size={props.size ?? VisualSizesEnum.EXTRA_LARGE}>{props.children}</StyledFloatingBar>
);
